import { Component } from '@angular/core';

@Component({
	selector: 'app-month',
	templateUrl: './month.component.html',
	styleUrls: ['./month.component.scss'],
})
export class MonthComponent {
	// bread crumb items
	breadCrumbItems!: Array<{}>;
	loadingExcel: boolean = false;
	submitted = false;
}
